module.exports = __webpack_public_path__ + "img/alfie-w8.2b61f73b.jpeg";